'use client';

import { useQueryClient } from '@tanstack/react-query';

export function useClearQueryCache() {
  const qc = useQueryClient();

  return async () => {
    qc.clear();
  };
}
